<template>
  <div>
    <div v-if="networkSiteLog && networkSiteLog.data.length">
      <div class="action-bar action-bar--without-paginator">
        <PageLimitSwitcher :active="filterObject.per_page" @click="setPageLimit"/>

        <div class="table-total">
          Total Items: {{ networkSiteLog && networkSiteLog.total }}
        </div>
      </div>

      <el-pagination
          background
          layout="prev, pager, next"
          :page-size="filterObject.per_page"
          :current-page="filterObject.page"
          :total="networkSiteLog.total"
          hide-on-single-page
          @current-change="changePage"
      />
    </div>

    <SiteLogList
        :loading="loading"
        :log="networkSiteLog && networkSiteLog.data"
    />

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageLimitSwitcher from '@/components/global/PageLimitSwitcher'
import SiteLogList from '@/components/client-sites/SiteLogList'

export default {
  name: 'NetworkSiteLog',
  components: {
    SiteLogList,
    PageLimitSwitcher
  },
  data() {
    return {
      loading: false,
      filterObject: {
        page: 1,
        per_page: 200
      }
    }
  },
  computed: {
    ...mapState('sites', [
      'activeNetworkSite',
      'networkSiteLog'
    ])
  },
  watch: {
    activeNetworkSite() {
      if (this.activeNetworkSite) {
        this.getLog()
      }
    }
  },
  methods: {
    ...mapActions('sites', [
      'fetchNetworkSiteLog'
    ]),
    async getLog() {
      this.loading = true
      this.filterObject = { ...this.activeNetworkSite }
      await this.fetchNetworkSiteLog(this.filterObject)
      this.loading = false
    },
    setPageLimit(val) {
      this.filterObject.per_page = val
      this.filterObject.page = 1
      this.getLog()
    },
    changePage(page) {
      this.filterObject.page = page
      this.getLog()
    }
  }
}
</script>
